(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.HarrodBoundaryMath = api;
})(function () {
  'use strict';

  function positive(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0;
  }

  function integer(value) {
    return positive(value) && Number.isSafeInteger(value);
  }

  function error(code) { return { error: code }; }

  function parseScreenWidth(value) {
    if (typeof value !== 'string') return null;
    var dimension = '(\\d+(?:[.,]\\d+)?)\\s*(cm|m)\\s*\\(\\s*([hw])\\s*\\)';
    var match = value.trim().match(new RegExp('^' + dimension + '\\s*[x×]\\s*' + dimension + '$', 'i'));
    if (!match || match[3].toLowerCase() === match[6].toLowerCase()) return null;
    var first = Number(match[1].replace(',', '.')) * (match[2].toLowerCase() === 'm' ? 100 : 1);
    var second = Number(match[4].replace(',', '.')) * (match[5].toLowerCase() === 'm' ? 100 : 1);
    if (!positive(first) || !positive(second)) return null;
    return match[3].toLowerCase() === 'w' ? first : second;
  }

  function rules(value) {
    if (value == null) value = {};
    if (typeof value !== 'object' || Array.isArray(value)) return error('quantityRule');
    if (value.available === false) return error('unavailable');
    var min = value.min == null ? 1 : value.min;
    var step = value.step == null ? 1 : value.step;
    var max = value.max == null ? Infinity : value.max;
    if (!integer(min) || !integer(step) || (max !== Infinity && (!integer(max) || max < min))) return error('quantityRule');
    return { min: min, step: step, max: max };
  }

  function input(length, width, rule) {
    if (!positive(length) || length > 10000) return error('length');
    if (!positive(width)) return error('width');
    return rules(rule);
  }

  // Normalize only floating-point noise around an integer boundary.
  function quotient(length, width) {
    var value = length * 100 / width;
    var nearest = Math.round(value);
    var tolerance = Number.EPSILON * 16 * Math.max(1, Math.abs(value));
    return Math.abs(value - nearest) <= tolerance ? nearest : value;
  }

  function screens(length, width, rule) {
    var constraints = input(length, width, rule);
    if (constraints.error) return constraints;
    var count = Math.ceil(quotient(length, width));
    if (!integer(count)) return error('quantity');
    var order = constraints.min + Math.ceil(Math.max(0, count - constraints.min) / constraints.step) * constraints.step;
    if (!integer(order)) return error('quantity');
    if (order > constraints.max) return error('maximum');
    var coverage = order * width / 100;
    if (!positive(coverage)) return error('quantity');
    return { count: count, order: order, width: width, centres: width,
      coverage: coverage, extra: Math.max(0, coverage - length) };
  }

  function pleached(length, width, rule) {
    var constraints = input(length, width, rule);
    if (constraints.error) return constraints;
    if (width < 120 || width > 180) return error('width');
    var fits = Math.floor(quotient(length, width));
    if (!Number.isSafeInteger(fits)) return error('quantity');
    if (fits < constraints.min) return error('minimum');
    var count = constraints.min + Math.floor((fits - constraints.min) / constraints.step) * constraints.step;
    if (!integer(count)) return error('quantity');
    if (count > constraints.max) return error('maximum');
    var centres = length * 100 / count;
    return { count: count, order: count, fits: fits, width: width, centres: centres,
      gap: Math.max(0, centres - width), coverage: count * width / 100 };
  }

  return Object.freeze({ parseScreenWidth: parseScreenWidth, screens: screens, pleached: pleached });
});
